import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'Core/components/Alert';
import { PrimaryButton, SecondaryOutlineButton } from 'Core/components/Button';

const TeleaudiologyReturnHandler = () => {
  const { t } = useTranslation();
  const [showReturnPrompt, setShowReturnPrompt] = React.useState(false);
  const [returnUrl, setReturnUrl] = React.useState('');

  React.useEffect(() => {
    // Check if user is returning from Teleaudiology financing flow
    const isTeleaudiologyFlow = sessionStorage.getItem('isTeleaudiologyFlow');
    const storedReturnUrl = sessionStorage.getItem('returnUrl');

    if (isTeleaudiologyFlow === 'true' && storedReturnUrl) {
      setShowReturnPrompt(true);
      setReturnUrl(storedReturnUrl);
    }
  }, []);

  const handleReturnToPayment = () => {
    // Clear the session storage
    sessionStorage.removeItem('isTeleaudiologyFlow');
    sessionStorage.removeItem('returnUrl');

    // Navigate back to the payment portal
    window.location.href = returnUrl;
  };

  const handleStayHere = () => {
    // Clear the session storage but stay on current page
    sessionStorage.removeItem('isTeleaudiologyFlow');
    sessionStorage.removeItem('returnUrl');
    setShowReturnPrompt(false);
  };

  if (!showReturnPrompt) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-50 border-b border-blue-200 p-4">
      <Alert type="infoLight" className="mb-0">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-semibold text-blue-800 mb-1">
              {t('teleaudiology.returnPrompt.title', 'Return to Payment Portal')}
            </h3>
            <p className="text-blue-700 text-sm">
              {t(
                'teleaudiology.returnPrompt.message',
                'Would you like to return to the payment portal to continue your session?'
              )}
            </p>
          </div>
          <div className="flex gap-2 flex-shrink-0">
            <SecondaryOutlineButton onClick={handleStayHere} className="text-sm px-4 py-2">
              {t('teleaudiology.returnPrompt.stay', 'Stay Here')}
            </SecondaryOutlineButton>
            <PrimaryButton onClick={handleReturnToPayment} className="text-sm px-4 py-2">
              {t('teleaudiology.returnPrompt.return', 'Return to Portal')}
            </PrimaryButton>
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default TeleaudiologyReturnHandler;
